import moment from 'moment';

class TruBlueConfig {
  constructor({
    regStartDate, regEndDate,
    claimStart, claimEnd,

  }) {
    // Default to the old hardcoded ranges if none are given.
    this.regStartDate = regStartDate ? moment(regStartDate) : moment().startOf('year');
    this.regEndDate = regEndDate ? moment(regEndDate) : moment().startOf('year').add(6, 'months').endOf('month');
    this.claimStart = claimStart ? moment(claimStart) : null;
    this.claimEnd = claimEnd ? moment(claimEnd) : null;
  }

  clone() {
    return new TruBlueConfig(this);
  }

  static fromApiFormat(config) {
    return new TruBlueConfig(JSON.parse(config));
  }
}

export default TruBlueConfig;
